export default __webpack_public_path__ + "static/media/logo-upload.eadcd1a3.svg";